let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kF1Zi")).then(() => parcelRequire('15XFj'));